import React from "react";

import "./styles/style-process-box.css";

// issue #31: o painel antigo era uma caixa branca com um Lottie generico e uma
// frase unica. Num upload real de ~80s ele ficava identico do inicio ao fim, sem
// dizer se o arquivo ainda subia, se estava na fila ou se ja processava, e por
// isso parecia travado. Aqui as etapas do fluxo ficam explicitas.

const ETAPAS = [
    { id: "envio", rotulo: "Enviando arquivo", detalhe: "Transferindo a planilha para o servidor" },
    { id: "fila", rotulo: "Na fila", detalhe: "Aguardando o processador da importacao" },
    { id: "processando", rotulo: "Importando dados", detalhe: "Lendo as linhas e gravando no sistema" },
];

// Traduz o status do ImportJob (ou a ausencia dele) para a etapa corrente.
const etapaAtual = (fase, statusDoJob) => {
    if (fase === "envio") return "envio";
    if (statusDoJob === "processing") return "processando";
    if (statusDoJob === "pending") return "fila";
    return fase || "fila";
};

const estadoDaEtapa = (idDaEtapa, idAtual) => {
    const ordem = ETAPAS.map((e) => e.id);
    const posicao = ordem.indexOf(idDaEtapa);
    const atual = ordem.indexOf(idAtual);
    if (posicao < atual) return "feito";
    if (posicao === atual) return "ativo";
    return "pendente";
};

const Etapa = ({ etapa, estado }) => (
    <li className="scm-painel__etapa" data-estado={estado}>
        <span className="scm-painel__marca" aria-hidden="true">
            <span className="scm-painel__ponto" />
        </span>
        <span>
            <span className="scm-painel__rotulo">{etapa.rotulo}</span>
            {estado === "ativo" ? (
                <span className="scm-painel__detalhe">{etapa.detalhe}</span>
            ) : null}
        </span>
    </li>
);

/**
 * Painel de progresso de uma operacao longa.
 *
 * Compativel com o uso antigo (`<ProcessBox message="..." />`), que continua
 * exibindo so a mensagem. As props novas ativam o trilho de etapas:
 *
 *   <ProcessBox fase="fila" statusDoJob={job.status} arquivo="DueList.xlsx" />
 */
const ProcessBox = ({ message, fase, statusDoJob, arquivo, progresso }) => {
    const detalhado = Boolean(fase || statusDoJob);
    const atual = etapaAtual(fase, statusDoJob);
    const enviando = atual === "envio" && typeof progresso === "number";

    return (
        <section className="scm-painel" aria-live="polite" aria-busy="true">
            <header>
                <h2 className="scm-painel__titulo">Importacao em andamento</h2>
                {arquivo ? <p className="scm-painel__arquivo">{arquivo}</p> : null}
            </header>

            {detalhado ? (
                <ol className="scm-painel__etapas">
                    {ETAPAS.map((etapa) => (
                        <Etapa key={etapa.id} etapa={etapa} estado={estadoDaEtapa(etapa.id, atual)} />
                    ))}
                </ol>
            ) : null}

            <div
                className={enviando ? "scm-painel__barra scm-painel__barra--valor" : "scm-painel__barra"}
                style={enviando ? { "--scm-progresso": `${progresso}%` } : undefined}
                role="progressbar"
                aria-valuenow={enviando ? progresso : undefined}
            />

            <p className="scm-painel__nota">
                {message || "Pode deixar esta aba aberta, avisamos assim que terminar."}
            </p>
        </section>
    );
};

export default ProcessBox;
